<template>
  <div class="video-style">
    <video-player
      class="video-player vjs-custom-skin"
      ref="videoPlayer"
      :playsinline="true"
      :options="playerOptions"
      @play="onPlayerPlay($event)"
      @pause="onPlayerPause($event)"
      @ended="onPlayerEnded($event)"
      @waiting="onPlayerWaiting($event)"
      @playing="onPlayerPlaying($event)"
      @loadeddata="onPlayerLoadeddata($event)"
      @timeupdate="onPlayerTimeupdate($event)"
      @canplay="onPlayerCanplay($event)"
      @canplaythrough="onPlayerCanplaythrough($event)"
      @statechanged="playerStateChanged($event)"
      @ready="playerReadied"
      @error="handleError"
      @progress="handleProgress"
    >
    </video-player>
    <!-- <video :src="videoSrc" controls class="video" ref="videoPlayer" style="width: calc(100% - 20px);height: 300px;"></video> -->
  </div>
</template>

<script>
let Hls = require('hls.js')

export default {
  props: ['videoSrc'],
  data () {
    return {
      videoId: '',
      // videoSrc: 'https://rim-multimedia-uat.pyamc.com/data/cham/multimedia/20220415/322bea86-2951-49cb-a4be-f4d7d32913ad.mp4/index.m3u8',
      hls: null,
      videoUrl: 'https://bitdash-a.akamaihd.net/content/sintel/hls/playlist.m3u8',
      playerOptions: {
        // sources: [
        //   {
        //     src: "https://rim-multimedia-uat.pyamc.com/data/iram/uatMultimedia/20220329/c984b3ff-2800-4fa6-817e-36d92b5c3680.mp4/index.m3u8", //url地址
        //   },
        // ],
        playbackRates: [0.5, 1.0, 1.25, 1.5, 2.0], // 可选的播放速度
        autoplay: false, // 如果为true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 是否视频一结束就重新开始。
        preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: 'zh-CN',
        aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [
          {
            // type: "video/mp4", // 类型
            src: ''
          }
          // {
          //   type: 'rtmp/mp4',
          //   src: 'rtmp://58.200.131.2:1935/livetv/hunantv'
          // }
        ],
        poster: '', // 封面地址
        notSupportedMessage: '此视频暂无法播放，请稍后再试', // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true, // 当前时间和持续时间的分隔符
          durationDisplay: true, // 显示持续时间
          remainingTimeDisplay: false, // 是否显示剩余时间功能
          fullscreenToggle: true, // 是否显示全屏按钮
          playToggle: {}, // 播放暂停按钮
          progressControl: {}, // 播放进度条
          // 音量按钮设置
          volumeMenuButton: {
            inline: false,
            vertical: true,
            horizontal: false
          }
        }
      }
    }
  },
  computed: {
    player () {
      return this.$refs.videoPlayer.player
    }
  },
  created () {
    // if ()
    // group1/M00/09/B3/ChQCJ2JYw1mASd9WABuQoYAhsaA080.mp4
    this.playerOptions.sources[0].src = this.videoSrc
    console.log(this.videoSrc)
  },
  mounted () {
    // this.getStream()
    this.videoId = this.$route.query.videoId
    console.log(this.$route.path)
  },

  methods: {
    // 播放回调
    onPlayerPlay (player) {
      if (this.$route.path === '/videoDetail') {
        this.clearViewCache('VideoList')
        this.addVideoPlayRecord()
      }
      // console.log('player play!', player)
      // 禁用进度条,拖动失效
      // document.getElementsByClassName(
      //   "vjs-progress-control"
      // )[0].style.pointerEvents = "none";

      // if (window.orientation !== undefined) {
      //   alert(111);
      //   screen.orientation.lock("landscape");
      // } else {
      //   alert(222);
      //   screen.orientation.lock("portrait");
      // }
    },
    // 新增播放记录
    addVideoPlayRecord () {
      this.axios.get(`api/video/addVideoPlayRecord?videoId=${this.videoId}`).then(res => {
        if (res.data.errorCode === 0) {
          // this.userReadRecordId = res.data.data
        } else {
          this.$message.warning(res.data.errorMessage)
        }
      })
    },
    // 暂停回调
    onPlayerPause (player) {
      // console.log('player pause!', player)
    },

    // 视频播完回调
    onPlayerEnded (player) {
      // console.log(player)
    },

    // DOM元素上的readyState更改导致播放停止
    onPlayerWaiting (player) {
      // console.log(player)
    },

    // 已开始播放回调
    onPlayerPlaying (player) {
      // console.log(player)
    },

    // 当播放器在当前播放位置下载数据时触发
    onPlayerLoadeddata (player) {
      // console.log(player)
    },

    // 当前播放位置发生变化时触发。
    onPlayerTimeupdate () {
      // console.log(player);

      // 判断移动端还是pc端
      if ('cordova' in window) {
        // if (player.player_.isFullscreen_ == true) {
        //   screen.orientation.lock("landscape");
        // } else {
        //   screen.orientation.lock("portrait");
        // }
      }
    },

    // 媒体的readyState为HAVE_FUTURE_DATA或更高
    onPlayerCanplay (player) {
      // console.log('player Canplay!', player)
    },

    // 媒体的readyState为HAVE_ENOUGH_DATA或更高。这意味着可以在不缓冲的情况下播放整个媒体文件。
    onPlayerCanplaythrough (player) {
      // console.log('player Canplaythrough!', player)
    },

    // 播放状态改变回调
    playerStateChanged () {
      // console.log("player current update state", playerCurrentState);
    },

    // 将侦听器绑定到组件的就绪状态。与事件监听器的不同之处在于，如果ready事件已经发生，它将立即触发该函数。。
    playerReadied (player) {
      // console.log('example player 1 readied', player)

      // 禁用进度条,拖动失效
      // document.getElementsByClassName(
      //   'vjs-progress-control'
      // )[0].style.pointerEvents = 'none'
    },
    handleError () {
      let e = document.getElementsByClassName('vjs-modal-dialog-content')
      if (e && e.length) {
        e.forEach(item => {
          item.innerHTML = '此视频暂无法播放，请稍后再试'
        })
      }
    },
    handleProgress () {
    },
    getStream () {
      if (Hls.isSupported()) {
        this.hls = new Hls()
        this.hls.loadSource(this.videoSrc)
        console.log('文件地址：：：', this.videoSrc)
        this.hls.attachMedia(this.$refs.videoPlayer)
        console.log(this.hls)
        console.log(this.hls.attachMedia(this.$refs.videoPlayer))
        this.hls.on(Hls.Events.MANIFEST_PARSED, () => {
          console.log('加载成功', this.videoSrc)
          this.$refs.videoPlayer.play()
        })
        this.hls.on(Hls.Events.ERROR, (event, data) => {
          console.log('加载失败', this.videoSrc)
        })
      } else if (
        this.$refs.videoPlayer.canPlayType('application/vnd.apple.mpegurl')
      ) {
        this.$refs.videoPlayer.src = this.videoSrc
        this.$refs.videoPlayer.addEventListener('loadedmetadata', function () {
          this.$refs.videoPlayer.play()
        })
      }
    },
    // 停止流
    videoPause () {
      if (this.hls) {
        this.$refs.videoPlayer.pause()
        this.hls.destroy()
        this.hls = null
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.video-style {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/StreamMediaVideo.vue